import { render, staticRenderFns } from "./ThirdStep.vue?vue&type=template&id=b210b2b0&scoped=true"
import script from "./ThirdStep.vue?vue&type=script&lang=ts"
export * from "./ThirdStep.vue?vue&type=script&lang=ts"
import style0 from "./ThirdStep.vue?vue&type=style&index=0&id=b210b2b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b210b2b0",
  null
  
)

export default component.exports